const team2025 = {
  title: "2025",
  members: [
    {
      name: "message.team.management",
      members: [
        {
          img: "/static/team/members/2024/Shawn_Killeen.jpg",
          fullName: "Shawn Killeen",
          role: "message.team.roles.captain",
          mail: "s.killeen.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/shawnkilleen/",
        },
        {
          img: "/static/team/members/2024/Thomas_Lefebvre.jpg",
          fullName: "Thomas Lefebvre",
          role: "message.team.roles.technical-director",
          mail: "t.lefebvre.formule.ets@gmail.com",
          linkedin: "https://ca.linkedin.com/in/thomas-lefebvre-31a161253/",
        },
        {
          img: "/static/team/members/maxim_brasseur.jpg",
          fullName: "Maxim Brasseur",
          role: "message.team.roles.co-technical-director",
          mail: "m.brasseur.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/maximbrasseur/",
        },
      ],
    },
    {
      name: "message.team.aerodynamic",
      members: [
        {
          img: "/static/team/members/2025/William_Lecavalier.jpg",
          fullName: "William Lecavalier",
          role: "message.team.roles.lead-aerodynamics",
          mail: "w.lecavalier.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/william-lecavalier/",
        },
        {
          img: "/static/team/members/maxim_brasseur.jpg",
          fullName: "Maxim Brasseur",
          role: "",
          mail: "m.brasseur.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/maximbrasseur/",
        },
        {
          img: "/static/team/members/2024/Hugues_Perrin.jpg",
          fullName: "Hugues Perrin",
          role: "",
          mail: "h.perrin.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/hugues-perrin-674924194/",
        },
        {
          img: "/static/team/members/2024/Nathan_Piha.jpg",
          fullName: "Nathan	Piha",
          role: "",
          mail: "n.piha.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/nathan-piha-7357722ab/",
        },
        {
          img: "/static/team/members/2025/Juliette_Dubois.jpg",
          fullName: "Juliette Dubois",
          role: "",
          mail: "j.dubois.formule.ets@gmail.com",
          linkedin: "",
        },
        {
          img: "/static/team/members/2025/Pauline_Gillet.jpg",
          fullName: "Pauline Gillet",
          role: "",
          mail: "",
          linkedin: "https://www.linkedin.com/in/paulinegillet6/",
        },
        {
          img: "/static/team/members/2025/Maxence_Wolf.jpg",
          fullName: "Maxence Wolf",
          role: "",
          mail: "m.wolf.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/maxence-wolf-17480b252/",
        },
        {
          img: "/static/team/members/2024/Casque_Homme.jpg",
          fullName: "Felix Chénier",
          role: "",
          mail: "f.chenier.formule.ets@gmail.com",
          linkedin: "",
        },
        {
          img: "/static/team/members/2024/Casque_Homme.jpg",
          fullName: "Clovis Girard",
          role: "",
          mail: "",
          linkedin: "",
        },
      ],
    },
    {
      name: "message.team.chassis",
      members: [
        {
          img: "/static/team/members/2024/Etienne_Paillereau.jpg",
          fullName: "Etienne Paillereau",
          role: "message.team.roles.lead-chassis",
          mail: "e.paillereau.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/etienne-paillereau-746855203",
        },
        {
          img: "/static/team/members/2024/Guillaume_Beaufort-Samson.jpg",
          fullName: "Guillaume Beaufort-Samson",
          role: "",
          mail: "g.beaufortsamson.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/guillaume-beaufort-samson-3110952a/",
        },
        {
          img: "/static/team/members/2025/Christian-Martin_Al-Jiries.jpg",
          fullName: "Christian-Martin Al-Jiries",
          role: "",
          mail: "cm.aljiries.formule.ets@gmail.com",
          linkedin: "",
        },
        {
          img: "/static/team/members/2025/Sebastian_Arancibia_Saldana.jpg",
          fullName: "Sebastian Arancibia Saldana",
          role: "",
          mail: "s.arancibiasaldana.formule.ets@gmail.com",
          linkedin: "",
        },
        {
          img: "/static/team/members/2025/Thomas_Joly.jpg",
          fullName: "Thomas Joly",
          role: "",
          mail: "t.joly.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/thomasjoly002/",
        },
      ],
    },
    {
      name: "message.team.dynamics",
      members: [
        {
          img: "/static/team/members/maxim_brasseur.jpg",
          fullName: "Maxim Brasseur",
          role: "message.team.roles.lead-dynamic",
          mail: "m.brasseur.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/maximbrasseur/",
        },
        {
          img: "/static/team/members/2024/Thomas_Lefebvre.jpg",
          fullName: "Thomas Lefebvre",
          role: "",
          mail: "t.lefebvre.formule.ets@gmail.com",
          linkedin: "https://ca.linkedin.com/in/thomas-lefebvre-31a161253/",
        },
        {
          img: "/static/team/members/2024/Guillaume_Beaufort-Samson.jpg",
          fullName: "Guillaume Beaufort-Samson",
          role: "",
          mail: "g.beaufortsamson.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/guillaume-beaufort-samson-3110952a/",
        },
        {
          img: "/static/team/members/2025/Louis-David_Boudrias.jpg",
          fullName: "Louis-David Boudrias",
          role: "",
          mail: "ld.boudrias.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/louis-david-boudrias/",
        },
        {
          img: "/static/team/members/2025/Laurent_Drewitt.jpg",
          fullName: "Laurent Drewitt",
          role: "",
          mail: "l.drewitt.formule.ets@gmail.com",
          linkedin: "",
        },
        {
          img: "/static/team/members/2025/Juliette_Dubois.jpg",
          fullName: "Juliette Dubois",
          role: "",
          mail: "j.dubois.formule.ets@gmail.com",
          linkedin: "",
        },
        {
          img: "/static/team/members/2025/Charles-Edouard_Mercier.jpg",
          fullName: "Charles-Édouard Mercier",
          role: "",
          mail: "",
          linkedin: "",
        },
      ],
    },
    {
      name: "message.team.electronics",
      members: [
        {
          img: "/static/team/members/2024/Shawn_Killeen.jpg",
          fullName: "Shawn Killeen",
          role: "message.team.roles.lead-electronic",
          mail: "s.killeen.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/shawnkilleen/",
        },
        {
          img: "/static/team/members/felix_groleau.jpg",
          fullName: "Félix Groleau",
          role: "",
          mail: "f.groleau.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/f%C3%A9lix-groleau-28b5b3231",
        },
        {
          img: "/static/team/members/jerome_bolduc.jpg",
          fullName: "Jérôme Bolduc",
          role: "",
          mail: "j.bolduc.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/j%C3%A9r%C3%B4me-bolduc-7083191b1/",
        },
        {
          img: "/static/team/members/2024/Alexis_St-Pierre.jpg",
          fullName: "Alexis St-Pierre",
          role: "",
          mail: "a.stpierre.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/alexis-st-pierre-48ab7a230/",
        },
        {
          img: "/static/team/members/2024/Raphael_Roumat.jpg",
          fullName: "Raphaël Roumat",
          role: "",
          mail: "r.roumat.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/rapha%C3%ABl-roumat-5a3015253/",
        },
        {
          img: "/static/team/members/2025/Anthony_Diotte.jpg",
          fullName: "Anthony Diotte",
          role: "",
          mail: "",
          linkedin: "https://www.linkedin.com/in/anthony-diotte/",
        },
      ],
    },
    {
      name: "message.team.drivetrain",
      members: [
        {
          img: "/static/team/members/2025/David_Casavant.jpg",
          fullName: "David Casavant",
          role: "message.team.roles.lead-drivetrain",
          mail: "d.casavant.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/david-casavant-b67152252/",
        },
        {
          img: "/static/team/members/maxim_brasseur.jpg",
          fullName: "Maxim Brasseur",
          role: "",
          mail: "m.brasseur.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/maximbrasseur/",
        },
        {
          img: "/static/team/members/2024/Francis_Bigaouette.jpg",
          fullName: "Francis Bigaouette",
          role: "",
          mail: "f.bigaouette.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/francis-bigaouette-a9b5bb24a/",
        },
        {
          img: "/static/team/members/2024/Martin_Lex.jpg",
          fullName: "Martin Lex",
          role: "",
          mail: "m.lex.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/martin-lex-b9a896150/",
        },
        {
          img: "/static/team/members/2025/Koraly_Lemieux.jpg",
          fullName: "Koraly Lemieux",
          role: "",
          mail: "",
          linkedin: "https://www.linkedin.com/in/koraly-lemieux-194904263/",
        },
      ],
    },
    {
      name: "message.team.powertrain",
      members: [
        {
          img: "/static/team/members/2024/Melina_Gasparini.jpg",
          fullName: "Mélina Gasparini",
          role: "message.team.roles.lead-powertrain",
          mail: "m.gasparini.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/melina-gasparini-cpi-cep-631991141/",
        },
        {
          img: "/static/team/members/2024/Alexis_St-Pierre.jpg",
          fullName: "Alexis St-Pierre",
          role: "",
          mail: "a.stpierre.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/alexis-st-pierre-48ab7a230/",
        },
        {
          img: "/static/team/members/2025/Jean-Francois_Perna.jpg",
          fullName: "Jean-François Perna",
          role: "",
          mail: "jf.perna.formule.ets@gmail.com",
          linkedin: "",
        },
        {
          img: "/static/team/members/2024/Casque_Homme.jpg",
          fullName: "Zakari Oulounis",
          role: "",
          mail: "z.oulounis.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/zakari-oulounis-201542145/",
        },
        {
          img: "/static/team/members/2025/Alexy_Cabeceiras.jpg",
          fullName: "Alexy Cabeceiras",
          role: "",
          mail: "alexy.cabeceiras@formule-ets.ca",
          linkedin: "https://ca.linkedin.com/in/alexy-cabeceiras-107b01354",
        },
      ],
    },
    {
      name: "message.team.machining",
      members: [
        {
          img: "/static/team/members/2025/Louis-David_Boudrias.jpg",
          fullName: "Louis-David Boudrias",
          role: "message.team.roles.lead-machining",
          mail: "ld.boudrias.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/louis-david-boudrias/",
        },
        {
          img: "/static/team/members/2024/Thomas_Lefebvre.jpg",
          fullName: "Thomas Lefebvre",
          role: "",
          mail: "t.lefebvre.formule.ets@gmail.com",
          linkedin: "https://ca.linkedin.com/in/thomas-lefebvre-31a161253/",
        },
        {
          img: "/static/team/members/maxim_brasseur.jpg",
          fullName: "Maxim Brasseur",
          role: "",
          mail: "m.brasseur.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/maximbrasseur/",
        },
        {
          img: "/static/team/members/2024/Etienne_Paillereau.jpg",
          fullName: "Etienne Paillereau",
          role: "",
          mail: "e.paillereau.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/etienne-paillereau-746855203",
        },
        {
          img: "/static/team/members/2025/Laurent_Drewitt.jpg",
          fullName: "Laurent Drewitt",
          role: "",
          mail: "l.drewitt.formule.ets@gmail.com",
          linkedin: "",
        },
      ],
    },
    {
      name: "message.team.driverless",
      members: [
        {
          img: "/static/team/members/2024/Nicolas_Gaulin-Metivier.jpg",
          fullName: "Nicolas Gaulin-Métivier ",
          role: "message.team.roles.lead-driverless",
          mail: "n.gaulinmetivier.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/nicolas-gaulin-m%C3%A9tivier-50850a258/",
        },
        {
          img: "/static/team/members/2024/Casque_Homme.jpg",
          fullName: "Victor Dang",
          role: "",
          mail: "victor.dang@formule-ets.ca",
          linkedin: "",
        },
        {
          img: "/static/team/members/2024/Casque_Homme.jpg",
          fullName: "Simon-Olivier Drapeau",
          role: "",
          mail: "simon-olivier.drapeau.1@ens.etsmtl.ca",
          linkedin: "https://ca.linkedin.com/in/simon-olivier-drapeau-674a98230/en",
        },
        {
          img: "/static/team/members/2024/Casque_Homme.jpg",
          fullName: "Pâcome Gasnier",
          role: "",
          mail: "pacome.gasnier@formule-ets.ca",
          linkedin: "",
        },
        {
          img: "/static/team/members/2024/Casque_Homme.jpg",
          fullName: "Pablo Hamel-Corôa",
          role: "",
          mail: "",
          linkedin: "",
        },
        {
          img: "/static/team/members/2024/Casque_Homme.jpg",
          fullName: "Dalil Merad",
          role: "",
          mail: "",
          linkedin: "",
        },

      ],
    },
    {
      name: "message.team.external_relationship",
      members: [
        {
          img: "/static/team/members/2024/Audrey_Barrier.jpg",
          fullName: "Audrey Barrier",
          role: "message.team.roles.lead-external-relationship",
          mail: "a.barrier.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/audrey-barrier-72279a234/",
        },
        {
          img: "/static/team/members/2024/Melina_Gasparini.jpg",
          fullName: "Mélina Gasparini",
          role: "",
          mail: "m.gasparini.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/melina-gasparini-cpi-cep-631991141/",
        },
        {
          img: "/static/team/members/2024/Alexandre_Remillard.jpg",
          fullName: "Alexandre Rémillard",
          role: "",
          mail: "a.remillard.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/alexandre-r%C3%A9millard-68b686260/",
        },
        {
          img: "/static/team/members/2025/Guillaume_Do_Khoa_Nguyen.jpg",
          fullName: "Guillaume Do Khoa Nguyen",
          role: "",
          mail: "guillaume.nguyen@formule-ets.ca",
          linkedin: "https://www.linkedin.com/in/guillaume-do-khoa-nguyen/",
        },
        {
          img: "/static/team/members/2025/Gabriel_Lecavalier.jpg",
          fullName: "Gabriel Lecavalier",
          role: "",
          mail: "gabriel.lecavalier@formule-ets.ca",
          linkedin: "https://www.linkedin.com/in/gabriel-lecavalier-174501282/",
        },
        {
          img: "/static/team/members/2025/Louane_Lohou.jpg",
          fullName: "Louane Lohou",
          role: "",
          mail: "louane.lohou@formule-ets.ca",
          linkedin: "https://www.linkedin.com/in/louane-lohou/",
        },
        {
          img: "/static/team/members/2025/Lyza_Yacini.jpg",
          fullName: "Lyza Yacini",
          role: "",
          mail: "",
          linkedin: "https://www.linkedin.com/in/lyza-yacini-763866346/",
        },
      ],
    },
    {
      name: "message.team.statics",
      members: [
        {
          img: "/static/team/members/2024/Audrey_Barrier.jpg",
          fullName: "Audrey Barrier",
          role: "message.team.roles.lead-cost",
          mail: "a.barrier.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/audrey-barrier-72279a234/",
        },
        {
          img: "/static/team/members/2024/Alexandre_Remillard.jpg",
          fullName: "Alexandre Rémillard",
          role: "message.team.roles.lead-business",
          mail: "a.remillard.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/alexandre-r%C3%A9millard-68b686260/",
        },
        {
          img: "/static/team/members/2024/Melina_Gasparini.jpg",
          fullName: "Mélina Gasparini",
          role: "",
          mail: "m.gasparini.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/melina-gasparini-cpi-cep-631991141/",
        },
        {
          img: "/static/team/members/2024/Shawn_Killeen.jpg",
          fullName: "Shawn Killeen",
          role: "",
          mail: "s.killeen.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/shawnkilleen/",
        },
        {
          img: "/static/team/members/2024/Casque_Homme.jpg",
          fullName: "Victor Dang",
          role: "",
          mail: "victor.dang@formule-ets.ca",
          linkedin: "",
        },
        {
          img: "/static/team/members/2025/Gabriel_Lecavalier.jpg",
          fullName: "Gabriel Lecavalier",
          role: "",
          mail: "gabriel.lecavalier@formule-ets.ca",
          linkedin: "https://www.linkedin.com/in/gabriel-lecavalier-174501282/",
        },
      ],
    },
  ],
};

export default team2025;
